<template>
    <div class="loginForm">
        <div class="container">
            <div class="imageContainer">
                <div class="version">{{this.wdm.version}}</div>
                <div class="error" id="error">{{ errorText }}</div>
            </div>
        </div>
        <div class="loginContainer">
            <div class="kundelogin">Kundelogin</div>
            <form>
            <input v-model="user" class="loginField" placeholder="Indtast brugernavn" type="text" id="user" />
            <input @keyup.enter="submit" v-model="password" class="loginField" placeholder="Indtast password" autocomplete="true" type="password" id="password" />
        
            <div class="loginCogB">
            <label class="loginCheck">Husk mig
                <input v-model="huskmig" type="checkbox" id="huskmig"/>
                <span class="checkmark"></span>
            </label>
            <div @click="submit" class="loginButton">LOG IND</div>
            </div>
        </form>
        </div>
    </div>
</template>

<script>

export default {
  
    name: 'LoginPage',
    inject:[ 'wdm'],
    data() { 
        return {
            user     : '',
            password : '',
            huskmig  : false,
            token : '',
            refreshToken: '',
            errorText: ''
        }
    },
  created() {
    this.huskmig = (localStorage.getItem('save')=='true')
    if (this.huskmig) {
       this.user = localStorage.getItem('user')
       this.refreshToken = localStorage.getItem('refreshToken')
    }
    this.token = sessionStorage.getItem('userToken')
    
    if (this.token) window.location.replace("/boxapp")

    if (this.refreshToken && this.huskmig) {
        const jwtExpiration = this.parseJwt(this.refreshToken).exp
        const now = Math.round(new Date().getTime()/1000)
        var diff = jwtExpiration - now
        //30 days = 2592000
        if (diff < 300 ) {
            this.password = ''
            this.huskmig = false
            this.refreshToken = ''
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('save')
        } else {
            this.password = '***********'
        }      
    }

  },
  methods : {
    submit() {

        if (this.user != localStorage.getItem('user')) {
            localStorage.removeItem('currentUser')
            if (this.password.includes('**********')) this.password = 'x'
        }

        if (this.user && this.password) this.getToken()
    },
    parseJwt(token){
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        return JSON.parse(jsonPayload);
      
    },
    async getToken() {
        var res = ''

        if (this.password.includes('**********')) {
            
            const headers   = { "Content-Type": "application/x-www-form-urlencoded" } 
            const body = "refresh_token="+this.refreshToken
            res = await fetch( '/api/dp/login/token', { "method": "POST", "headers": headers, "body" : body } )
        } else {
            const headers   = { "Content-Type": "application/json" } 
            const body = JSON.stringify({ "user" : this.user, "password":this.password })
            res = await fetch( '/api/dp/login', { "method": "POST", "headers": headers, "body" : body } )
        }
        this.password = '**********'
        if (res.ok) { 
                console.log('successful login/renew')
                document.getElementById("error").style.display = "none";
                var resultat = await res.json()

                sessionStorage.setItem('userToken', resultat.token)
                sessionStorage.setItem('refreshToken', resultat.refreshToken)
                localStorage.setItem('user', this.user)
                if (this.huskmig) {
                    localStorage.setItem('refreshToken', resultat.refreshToken)
                    localStorage.setItem('save', this.huskmig)
                } else {
                    localStorage.removeItem('refreshToken')
                    localStorage.removeItem('save')
                }

                window.location.replace("/boxapp"); 
            } else if (res.status==406) {
                this.errorText='Forkert brugernavn eller kodeord.'
                document.getElementById("error").style.display = "block";
                this.password =''
            } else if (res.status==403) {
                this.errorText='Dine gemte konto informationer er ugyldige.'
                document.getElementById("error").style.display = "block";
                this.password = ''
                this.huskmig = false
                this.refreshToken = ''
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('save')
            } else {
                this.errorText='Det ser ud til at serveren er lukket - vent et par minutter og tryk så OK..('+String(res.status)+')'
                document.getElementById("error").style.display = "block";
            }
    }
  }
};

</script>

<style scoped>
.version {
    color: grey;
    text-align: left;
    font-size: 8px;
    padding-left:2px;
}
.error {
    position:absolute;
    background-color:rgba(255, 0 , 0, 0.9);
    border: 3px solid;
    color: white;
    border-color: red;
    height: 100px;
    top: 150px;
    left: calc((100%)/2 - 150px);
    margin: auto;
    width: 300px;
    vertical-align: middle;
    font-size: 30px;
    font-weight: bold;
    opacity: .7;
    border-radius: 25px;
    display: none;
}

.loginCogB {
    margin: auto;
    display: inline-flex;
    width: 325px;
    height: 75px;
}
.loginCheck {
  margin-top: 15px;
  width: 120px;
  position: absolute;
  padding-top: 9px;
  padding-left: 30px;
  padding-right: 20px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 3px;
  height: 35px;
  margin-left: 20px;
}

/* Hide the browser's default checkbox */
.loginCheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  transition: 1.3s;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 15;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid;
  
}

/* On mouse-over, add a grey background color */
.loginCheck:hover input ~ .checkmark {
    border-color: grey;
}

/* When the checkbox is checked, add a blue background */
.loginCheck input:checked ~ .checkmark {
  background-color: #FFFFFF;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.loginCheck input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.loginCheck .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid var(--nomeco-green);
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.loginButton {
    margin-left: 200px;
    margin-top: 10px;
    text-align: center;
    width: 100px;
    height: 20px;
    border-radius: 25px;
    background-color: var(--nomeco-lightgreen);
    border: 0px;
    color: black;
    font-weight: bold;
    font-size: 15px;
    padding:15px;
    opacity: 1;
    transition: 0.3s;
    cursor: pointer;
}

.loginButton:hover {
    opacity: 0.6;
}
.loginForm {
    height: 520px;
    
    background-image: url('@/assets/Site-ONE-org_1.webp');
    background-position: top;
    background-repeat: no-repeat;
    background-size:auto;

}

.loginContainer {
    display:inline-block;
    color: white;
    background-color: var(--nomeco-green);
    height:170px;
    width: calc(100% - 120px); 
    text-align:  left;
    padding: 20px;
    padding-left: 100px;
}

.kundelogin {
    font-size: 30px;
    font-weight: bold;
    margin: 0px;
    margin-bottom: 20px;
    padding:0px;
}
.loginField {
    padding-left: 10px;
    position:unset;
    height: 50px;
    width: 270px;
    font-size: 16px;
    border: 1px solid;
    border-color: lightgrey;
    border-radius: 3px;
}
.container {
    margin: 0px;
    width: calc(100vh-1px);
    
}
.loginImage {
    width: 100vh;
    max-height:300px;
    

}
.imageContainer {

    height: 350px;

}



@media screen and (max-width: 880px) {
    
    .loginForm {
        height: 400px;
    }

    .imageContainer {
        height: 300px;
        padding:0px;
    }

    .loginContainer {
        height: 250px;
        padding-left: 10px;
        width: calc(100% - 30px)
    }
    .loginField {
        width: 360px;
        padding-left: 20px;
       
    }
}

@media screen and (max-width: 745px) { 

.loginField {
    width: 340px;
   
}

}

@media screen and (max-width: 500px) { 

    .loginForm {
        height: 500px
    }

    .loginField {
        width: 290px;
        
    }

    .loginButton {
    margin-left: 225px;
    }

    .loginForm {
    background-size: 200% 50%;

    }

    .imageContainer {
    height: 210px;

}

    .error {
        top: 50px;
    }

}
</style>